export default {"src":"/_next/static/media/arrow_chev_right.2f5abbc5.svg","height":29,"width":29};